import axios from "axios";
import { MAIN_URL } from "../Configurations/Urls";

export async function fetchOrganizationLevels(orgId, { activeOnly = true } = {}) {
  const query = activeOnly ? "?active_only=1" : "";
  const response = await axios.get(
    `${MAIN_URL}/api/organizations/${orgId}/organization-level${query}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );
  return response.data?.Levels || response.data?.data || [];
}

export async function fetchOrganizationLevelById(orgId, levelId) {
  const response = await axios.get(
    `${MAIN_URL}/api/organizations/${orgId}/organization-level/${levelId}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );
  return response.data?.organizationlevel || response.data?.Level;
}

export async function createOrganizationLevel(orgId, payload) {
  const response = await axios.post(
    `${MAIN_URL}/api/organizations/${orgId}/organization-level`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );
  return response.data;
}

export async function updateOrganizationLevel(orgId, levelId, payload) {
  const response = await axios.put(
    `${MAIN_URL}/api/organizations/${orgId}/organization-level/${levelId}`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );
  return response.data;
}

export async function deleteOrganizationLevel(orgId, levelId) {
  const response = await axios.delete(
    `${MAIN_URL}/api/organizations/${orgId}/organization-level/${levelId}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );
  return response.data;
}

export async function fetchOrganizationHierarchy(orgId) {
  const response = await axios.get(
    `${MAIN_URL}/api/organizations/${orgId}/organization-level/hierarchy`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );
  return {
    tree: response.data?.tree || [],
    levels: response.data?.levels || [],
    people: response.data?.people || [],
    employmentTypes: response.data?.employment_types || [],
    totalEmployees: response.data?.total_employees ?? 0,
  };
}
